<template>
	<Loader v-if="loading" />
	<div v-else>

		<div
			class="small-margin-bottom">
			<button
				class="small"
		    	:disabled="saving"
		    	v-on:click="update">
		    	Save
		    </button>

		    <button
		    	class="small small-margin-left"
		    	:disabled="!can_run"
		    	v-on:click="run">
		    	Run
		    </button>
		</div>

		<div class="flex">
			<div class="sidebar">
				<div
					class="list-group-container"
					style="margin-bottom: 10px;"
					v-for="(group, g) in methodGroups">
					<div class="list-group-title">{{ g }}</div>
					<draggable
						class="list-group"
						:list="group"
						:clone="clone"
						:group="{ name: 'items', pull: 'clone', put: false }">
				        <div
				          	class="list-group-item"
				          	v-for="(element, index) in group"
				          	:key="element.method"
				        	>
				          	{{ humanizedName(element.method) }}
				        </div>
				    </draggable>
				</div>
			</div>

			<div>
				<draggable
					class="instruction-items"
					v-model="instructions"
					:group="{ name: 'items', put: true }">
			        <div
			          	class="instruction-item"
			          	v-for="(instruction, index) in instructions"
			          	:key="instruction.id"
			        	>
			        	<div class="method">
			          		<div class="method-name">{{ humanizedName(instruction.method) }}</div>
			          		<div class="method-description">
			          			{{ getDescription(instruction.method) }}
			          		</div>
			          	</div>

			          	<div class="arguments">
				          	<div v-for="(arg, a) in getArguments(instruction.method)">
				          		<MaterialText
				          			:label="arg.name"
				          			v-model="instruction.arguments[a]"
				          			style="width: 100px"
				          			/>
				          	</div>
				       	</div>

			          	<div>
			          		<button
			          			class="small gray"
			          			v-on:click="remove(index)">X</button>
			          	</div>
			        </div>
			    </draggable>

			</div>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    id: {
      required: true
    }
  },
  data: () => ({
    loading: false,
    saving: false,
    data: {},
    instructions: [],
    unique_index: 0,
    can_run: false
  }),
  watch: {
    instructions: {
      deep: true,
      handler () {
        this.can_run = false
      }
    }
  },
  computed: {
    methodGroups () {
      var list = {}

      for (var method of this.data.methods) {
        if (!list[method.adapter]) {
          list[method.adapter] = []
        }

        if (method.annotations.filter(
          row => row.type == 'testcase' && row.text == 'private'
        ).length > 0) {
          continue
        }

        list[method.adapter].push({
          method: method.method,
          arguments: []
        })
      }

      return list
    }
  },
  methods: {
    humanizedName (name) {
      return name.substr(0, 1).toUpperCase() +
					name.replace(/[A-Z]/g, function (m) {
					  return ' ' + m.toLowerCase()
					}).substr(1)
    },
    getDescription (methodName) {
      for (var annotation of this.getAnnotations(methodName)) {
        if (annotation.type === 'description') {
          return annotation.text
        }
      }

      return null
    },
    getAnnotations (methodName) {
      for (var method of this.data.methods) {
        if (methodName == method.method) {
          return method.annotations
        }
      }
    },
    run () {
      this.$emit('run')
    },
    remove (i) {
      Vue.delete(this.instructions, i)
    },
    clone (item) {
      item.id = this.unique_index

      this.unique_index++

      return item
    },
    getArguments (method) {
      for (var m of this.data.methods) {
        if (m.method == method) {
          return m.arguments
        }
      }
    },
    update () {
      Vue.$api.patch('/testing-template/' + this.id, {
        instructions: this.instructions
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.onUpdate()
      })
    },
    onUpdate () {
      this.can_run = true
    },
    load () {
      Vue.$api.get('/testing-template/' + this.id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.onLoad(data)
      })
    },
    onLoad (data) {
      this.data = data

      setTimeout(() => this.can_run = true, 100)

      for (var instruction of data.instructions) {
        Vue.set(
          this.instructions,
          this.instructions.length,
          {
            method: instruction.method,
            arguments: JSON.parse(instruction.arguments),
            id: this.unique_index
          }
        )

        this.unique_index++
      }
    }
  },
  created () {
    this.load()
  }
}
</script>

<style lang="less" scoped>
	.sidebar {
		width: 300px;
		padding-right: 15px;
		margin-right: 15px;
		flex-shrink: 0;
		overflow-y: auto;
		max-height: 500px;
	}
	.list-group-container:first-of-type .list-group-title {
			// border-top: 1px solid #ddd;
	}
	.list-group-title {
		padding-top: 10px;
		padding-bottom: 4px;
		font-weight: 700;
		// background: #efefef;
		border-bottom: 1px solid #eee;
		border-top: none;
	}
	.list-group {
		.list-group-item {
			padding: 10px;
			cursor: move;
			border: 1px solid #eee;
			border-top: none;
		}
	}
	.instruction-items {
		position: relative;
		min-height: 200px;
		width: 600px;
		background: #efefef;
		border-top: 1px solid #eee;
		padding-bottom: 60px;
		.instruction-item {
			background: #fff;
			border: 1px solid #eee;
			border-top: none;
			padding: 15px;
			margin: 5px;
			display: flex;
			align-items: center;
			.method {
				padding-right: 15px;
				width: 300px;
				cursor: move;
				.method-name {
					font-weight: 700;
				}
				.method-description {
					margin-top: 2px;
					font-weight: 300;
					font-size: 13px;
				}
			}
			.arguments {
				flex-grow: 1;
			}
		}
		&::after {
			position: absolute;
			bottom: 5px;
			left: 5px;
			right: 5px;
			content: "Drop here";
			height: 20px;
			text-align: center;
			padding: 15px;
			border: 2px dashed #ddd;
		}
	}
</style>
